import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import { alert } from './alert.module';
import { authentication } from './authentication.module';
import { brands } from './brands.module';
import { clients } from './clients.module';
import { collections } from './collections.module';
import { favorites } from './favorites.module';
import { ingredients } from './ingredients.module';
import { instructions } from './instructions.module';
import { notifications } from './notifications.module';
import { operators } from './operators.module';
import { products } from './products.module';
import { recipes } from './recipes.module';
import { reportings } from './reportings.module';
import { settings } from './settings.module';
import { socials } from './social.module';
import { tags } from './tags.module';
import { taggroups } from './taggroups.module';
import { todos } from './todos.module';
import { units } from './units.module';
import { users } from './users.module';
import { comments } from './comments.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        alert,
        authentication,
        brands,
        clients,
        collections,
        favorites,
        ingredients,
        instructions,
        notifications,
        operators,
        products,
        recipes,
        reportings,
        settings,
        socials,
        tags,
        taggroups,
        todos,
        units,
        users,
        comments
    },
    plugins: [createPersistedState()],
    getters: {
      userIsAdmin: state => { if(state.authentication.user.token) { return state.authentication.user.user.securityLevel > 1 } else { return false }},
      userIsSystem: state => { if(state.authentication.user.token) { return  state.authentication.user.user.securityLevel > 2 } else { return false }},
      currentTag:  state => { if(state.tags.current) { return state.tags.current } else { return false }},
      savedInstructions:  state => { if(state.instructions.saved) { return state.instructions.saved } else { return false }},
      savedIngredients:  state => { if(state.ingredients.saved) { return state.ingredients.saved } else { return false }},
      recipesLoading: state => { return state.recipes.loading;},
      ingredientsLoading: state => { return state.ingredients.loading;}
    },
});